module.exports = __webpack_public_path__ + "img/faelflix.d3ef8bc2.png";